import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { TokenService, ConfigService } from "common";
import { ResourcesLoaderService, ADPResourceService as ResourceService } from "digital-core";

@Injectable()
export class ViewResourcesResolver
   {
  firstLoad = true;
  constructor(private resourcesLoader: ResourcesLoaderService,
    private resourceService: ResourceService,
    private tokenService: TokenService,
    private configService: ConfigService
  ) { }
  async resolve(route: ActivatedRouteSnapshot, rstate: RouterStateSnapshot) {
    
    const page = route.data["view"];
    let components: string = route.data["components"];
    components = this.resourceService.differentialScope(components);
    if (!components) {
      throw new Error(`There is no Components associated to the route: ${route.url}`);
    }

    const sp = this.configService.startingPage;
    if (!!sp && sp.includes(page)) {// for D2C and  Dashboard page only
      const currentToken = this.tokenService.getAccessToken();
      if (!currentToken) {// if Token is not available for Dashboard
        await this.tokenService.returnToken().toPromise();
      }
    }

    if (window['config'].core.clientCMS == null || window['config'].core.clientCMS.length < 1) {
      this.firstLoad = false;
      return null;
    }

    var resources = await this.resourcesLoader.loadAllPageResources(components, false, this.firstLoad).toPromise();
    this.resourceService.setGlobalResources(resources.resources);
    this.resourceService.setGlobalLabels(resources.labels);
    this.firstLoad = false;
    return resources;
  }
}
